import { NavigationContainer, DefaultTheme, DarkTheme } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import {createDrawerNavigator, DrawerItem} from '@react-navigation/drawer';
import { DrawerActions } from '@react-navigation/native';
import * as React from 'react';
import {ColorSchemeName, Dimensions, Image, TouchableOpacity, useWindowDimensions, View} from 'react-native';
import {
    Octicons,
    MaterialCommunityIcons,
    MaterialIcons,
    FontAwesome5,
    Ionicons,
    Entypo,
    SimpleLineIcons
} from '@expo/vector-icons';


import { RootStackParamList } from '../types';
import LinkingConfiguration from './LinkingConfiguration';
import Colors from "../constants/Colors";

import DrawerContent from "./DrawerContent";
import Dashboard from "../screens/Dashboard";
import Home from "../screens/Home";
import Analytics from "../screens/Analytics";
import Settings from "../screens/Settings";
import {Avatar} from "react-native-paper";
import VerifyMode from "../screens/VerifyMode";
import VerifyMode1 from "../screens/VerifyMode1";
import VerifyMode2 from "../screens/VerifyMode2";
import VerifyMode3 from "../screens/VerifyMode3";
import StudentProfile from "../screens/StudentProfile";
import Credentials from "../screens/Credentials";
import HomePage from "../screens/HomePage";



// If you are not familiar with React Navigation, we recommend going through the
// "Fundamentals" guide: https://reactnavigation.org/docs/getting-started
export default function Navigation({ colorScheme }: { colorScheme: ColorSchemeName }) {
  return (
    <NavigationContainer
      linking={LinkingConfiguration}
      theme={colorScheme === 'dark' ? DarkTheme : DefaultTheme}>
      <Sidebar />
    </NavigationContainer>
  );
}

// A root stack navigator is often used for displaying modals on top of all other content
// Read more here: https://reactnavigation.org/docs/modal
const Stack = createStackNavigator<RootStackParamList>();
const Drawer = createDrawerNavigator();

function Sidebar() {

    const dimensions = useWindowDimensions();

    const isLargeScreen = dimensions.width >= 768;

    return (
        <Drawer.Navigator
            openByDefault
            drawerType={isLargeScreen ? 'permanent' : 'back'}
            drawerStyle={{
                backgroundColor: '#000000',
                minWidth: '4%',
                maxWidth: '5%',
                borderRadius: 25,
                margin: 10,
            }}
            drawerContent={(props) => <DrawerContent {...props} />}
        >
            <Drawer.Screen
                name="Dashboard"
                component={Dashboard}
            />
            <Drawer.Screen
                name="Verify"
                component={Home}
            />
            <Drawer.Screen
                name="Analytics"
                component={Analytics}
            />
            <Drawer.Screen
                name="Verify-Mode"
                component={VerifyMode}
            />
            <Drawer.Screen
                name="Verify-Country"
                component={VerifyMode1}
            />
            <Drawer.Screen
                name="Verify-Ruach"
                component={VerifyMode2}
            />
            <Drawer.Screen
                name="Student"
                component={StudentProfile}
            />
            <Drawer.Screen
                name="Credential"
                component={Credentials}
            />
            <Drawer.Screen
                name="Settings"
                component={Settings}
            />
        </Drawer.Navigator>
    );
}


function RootNavigator({navigation}) {

    return (
        <Stack.Navigator screenOptions={{
            headerStyle: {
                backgroundColor: 'white',
            },
            headerTintColor: 'white',
            headerTitleAlign: 'left',
            headerTitleStyle: {
                fontWeight: 'bold',
            }
        }}>
            <Stack.Screen
                name="Home"
                component={HomePage}
                options={{
                    headerBackTitle: false,
                    headerTitle: false,
                    headerTransparent: true,
                }}
            />
            <Stack.Screen
                name="Dashboard"
                component={Dashboard}
                options={{
                    headerBackTitle: true,
                    headerTitle: false,
                    headerTransparent: true,
                }}
            />
            <Stack.Screen
                name="Analytics"
                component={Analytics}
                options={{
                    headerBackTitle: true,
                    headerTitle: false,
                    headerTransparent: true,
                }}
            />
            <Stack.Screen
                name="Settings"
                component={Settings}
                options={{
                    headerBackTitle: true,
                    headerTitle: false,
                    headerTransparent: true,
                }}
            />
        </Stack.Navigator>
    );
}
